import { render, staticRenderFns } from "./SignDetailsStep.vue?vue&type=template&id=390652d4&"
import script from "./SignDetailsStep.vue?vue&type=script&lang=js&"
export * from "./SignDetailsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports